// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickLinksCard_ql__GQZNB {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-fash-primary-4);
  color: var(--color-dark);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
}
.QuickLinksCard_ql__title__WMSzo {
  padding: 0;
  margin: 0;
  font-size: var(--default-font-size);
  font-weight: 700;
  margin-bottom: 3rem;
}
.QuickLinksCard_ql__content__QKbvt {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
  margin: 2rem 0 2rem 0;
}
.QuickLinksCard_ql__content__QKbvt > :not(:last-child) {
  margin-bottom: 2rem;
}
@media only screen and (max-width: 50em) {
  .QuickLinksCard_ql__content__QKbvt > :not(:last-child) {
    margin-bottom: 4rem;
  }
}
.QuickLinksCard_ql__link__Hg6zh {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.QuickLinksCard_ql__link__Hg6zh:hover {
  color: var(--color-fash-primary-3);
  font-weight: 700;
}
.QuickLinksCard_ql__link__Hg6zh p {
  margin: 0;
  padding: 0;
}
.QuickLinksCard_ql__icon__JDxle {
  font-size: 2.2rem;
}

.QuickLinksCard_reference__kZm-G {
  display: flex;
  background-color: var(--color-fash-black);
  border-radius: 1rem;
  padding: 2rem;
  color: var(--color-white);
  gap: 2rem;
  width: 100%;
  margin-bottom: 2rem;
}
@media only screen and (max-width: 43.75em) {
  .QuickLinksCard_reference__kZm-G {
    flex-direction: column;
    width: 100%;
  }
}
.QuickLinksCard_reference__copy__jcUb0 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  color: var(--color-fash-black);
  cursor: pointer;
  border-radius: 0.5rem;
  align-items: center;
  background-color: var(--color-white);
  padding: 1rem;
  width: 100%;
  gap: 2rem;
}
.QuickLinksCard_reference__copy__jcUb0:hover {
  transition: 0.5s;
  background-color: var(--color-light-grey);
}
.QuickLinksCard_reference__copy__icon__XYZHv {
  font-size: 3.2rem;
}
.QuickLinksCard_reference__link__VgLCp {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/AppHome/QuickLinksCard.module.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,mBAAA;EACA,6CAAA;EACA,wBAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;AADF;AAGE;EACE,UAAA;EACA,SAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,qBAAA;AAFJ;AAII;EACE,mBAAA;AAFN;AAGM;EAFF;IAGI,mBAAA;EAAN;AACF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAFJ;AAII;EACE,kCAAA;EACA,gBAAA;AAFN;AAKI;EACE,SAAA;EACA,UAAA;AAHN;AAOE;EACE,iBAAA;AALJ;;AAQA;EACE,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AALF;AAOE;EAVF;IAWI,sBAAA;IACA,WAAA;EAJF;AACF;AAME;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,8BAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;AAJJ;AAMI;EACE,gBAAA;EACA,yCAAA;AAJN;AAOI;EACE,iBAAA;AALN;AASE;EACE,WAAA;AAPJ","sourcesContent":["@import \"../variables/breakpoints\";\n\n.ql {\n  width: 100%;\n  border-radius: 2rem;\n  background-color: var(--color-fash-primary-4);\n  color: var(--color-dark);\n  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n  box-sizing: border-box;\n  padding: 3.5rem 2rem;\n\n  &__title {\n    padding: 0;\n    margin: 0;\n    font-size: var(--default-font-size);\n    font-weight: 700;\n    margin-bottom: 3rem;\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    box-sizing: border-box;\n    margin: 2rem 0 2rem 0;\n\n    & > :not(:last-child) {\n      margin-bottom: 2rem;\n      @media only screen and (max-width: $bp-medium) {\n        margin-bottom: 4rem;\n      }\n    }\n  }\n\n  &__link {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n\n    &:hover {\n      color: var(--color-fash-primary-3);\n      font-weight: 700;\n    }\n\n    p {\n      margin: 0;\n      padding: 0;\n    }\n  }\n\n  &__icon {\n    font-size: 2.2rem;\n  }\n}\n.reference {\n  display: flex;\n  background-color: var(--color-fash-black);\n  border-radius: 1rem;\n  padding: 2rem;\n  color: var(--color-white);\n  gap: 2rem;\n  width: 100%;\n  margin-bottom: 2rem;\n\n  @media only screen and (max-width: $bp-700) {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  &__copy {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    color: var(--color-fash-black);\n    cursor: pointer;\n    border-radius: 0.5rem;\n    align-items: center;\n    background-color: var(--color-white);\n    padding: 1rem;\n    width: 100%;\n    gap: 2rem;\n\n    &:hover {\n      transition: 0.5s;\n      background-color: var(--color-light-grey);\n    }\n\n    &__icon {\n      font-size: 3.2rem;\n    }\n  }\n\n  &__link {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ql": `QuickLinksCard_ql__GQZNB`,
	"ql__title": `QuickLinksCard_ql__title__WMSzo`,
	"ql__content": `QuickLinksCard_ql__content__QKbvt`,
	"ql__link": `QuickLinksCard_ql__link__Hg6zh`,
	"ql__icon": `QuickLinksCard_ql__icon__JDxle`,
	"reference": `QuickLinksCard_reference__kZm-G`,
	"reference__copy": `QuickLinksCard_reference__copy__jcUb0`,
	"reference__copy__icon": `QuickLinksCard_reference__copy__icon__XYZHv`,
	"reference__link": `QuickLinksCard_reference__link__VgLCp`
};
export default ___CSS_LOADER_EXPORT___;
